"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export function HomeLink({
  children,
  className,
  "aria-label": ariaLabel,
}: {
  children: React.ReactNode;
  className?: string;
  "aria-label"?: string;
}) {
  const pathname = usePathname();

  return (
    <Link
      href="/"
      className={className}
      aria-label={ariaLabel}
      onClick={() => {
        if (pathname === "/") {
          window.dispatchEvent(new CustomEvent("reset-converter"));
        }
      }}
    >
      {children}
    </Link>
  );
}
